module.exports = __webpack_public_path__ + "static/img/kwh_item_image5.a0766d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/programme/kwh_item_image5.png
// module id = Hm5A
// module chunks = 1